import React from "react";
import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import {
  Calendar,
  CalendarClock,
  CalendarOff,
  CalendarPlus,
  ClipboardX,
  ListChecks,
  Timer,
} from "lucide-react";
import { MetricCard } from "../shared";
import { TEAM_ICON_COLOR, TEAM_ICON_SIZE } from "./constants";
import type { TeamStaffDetailKpi } from "./staffDetailTypes";
import { TEAM_KPI_TITLE_KEYS } from "./teamKpiTitleKeys";

const KPI_ICONS: Record<string, React.ReactNode> = {
  "Tasks completed": <ListChecks />,
  "Tasks cancelled": <ClipboardX />,
  "Avg time on task": <Timer />,
  Shifts: <Calendar />,
  "Shift request": <CalendarPlus />,
  Delays: <CalendarClock />,
  "Day off": <CalendarOff />,
};

function translateKpiTitle(title: string, t: TFunction): string {
  const key = TEAM_KPI_TITLE_KEYS[title];
  if (!key) {
    return title;
  }
  return t(`analytics.${key}`, title);
}

interface TeamStaffDetailKpiCardsProps {
  kpis: TeamStaffDetailKpi[];
}

export const TeamStaffDetailKpiCards: React.FC<
  TeamStaffDetailKpiCardsProps
> = ({ kpis }) => {
  const { t } = useTranslation();
  const rowTop = kpis.slice(0, 3);
  const rowBottom = kpis.slice(3);

  return (
    <div className="flex w-full flex-col gap-3">
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-3">
        {rowTop.map((kpi) => (
          <MetricCard
            key={kpi.title}
            title={translateKpiTitle(kpi.title, t)}
            value={kpi.value}
            delta={kpi.delta}
            trend={kpi.trend}
            icon={KPI_ICONS[kpi.title]}
            iconColor={TEAM_ICON_COLOR}
            iconSize={TEAM_ICON_SIZE}
            width="fill"
          />
        ))}
      </div>
      {rowBottom.length > 0 ? (
        <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
          {rowBottom.map((kpi) => (
            <MetricCard
              key={kpi.title}
              title={translateKpiTitle(kpi.title, t)}
              value={kpi.value}
              delta={kpi.delta}
              trend={kpi.trend}
              icon={KPI_ICONS[kpi.title]}
              iconColor={TEAM_ICON_COLOR}
              iconSize={TEAM_ICON_SIZE}
              width="fill"
            />
          ))}
        </div>
      ) : null}
    </div>
  );
};
